import { Route, Switch } from "react-router-dom";
import { StudioWrapper } from "./StudioWrapper";
export const StudioApp = () => {
  return <Switch data-sentry-element="Switch" data-sentry-component="StudioApp" data-sentry-source-file="index.tsx">
      <Route path="/studio" render={() => <StudioWrapper />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
    </Switch>;
};
export default StudioApp;